export class GridRowActionItemExtras {
  constructor(public visibility: boolean, public hide: boolean, public pinned : boolean ) {
  }
}
